// src/Dashboard/pages/user/PassageCeintureDocuments/PassageCeintureDocumentsDashboard.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";

import { usePassageCeintureDocuments } from "./hooks/usePassageCeintureDocuments";

import PassageCeintureDocumentsHeader from "./components/PassageCeintureDocumentsHeader";
import PassageCeintureDocumentsKpis from "./components/PassageCeintureDocumentsKpis";
import PassageCeintureDocumentsToolbar from "./components/PassageCeintureDocumentsToolbar";
import PassageCeintureDocumentCard from "./components/PassageCeintureDocumentCard";
import PassageCeintureDocumentDrawer from "./components/PassageCeintureDocumentDrawer";
import PassageCeintureDocumentSkeleton from "./components/PassageCeintureDocumentSkeleton";
import PassageCeintureDocumentsEmptyState from "./components/PassageCeintureDocumentsEmptyState";

export default function PassageCeintureDocumentsDashboard() {
  useScrollToTop();

  const {
    loading,
    documents,
    filteredDocuments,
    visibleDocuments,
    belts,
    canManage,

    ui,
    debouncedSearch,
    setDebouncedSearch,
    updateUi,
    resetFilters,
    loadMore,

    stats,

    openedDocument,
    setOpenedDocument,
    editingDocument,
    setEditingDocument,
    drawerMode,
    setDrawerMode,

    openCreateDrawer,
    openEditDrawer,
    openReadDrawer,
    closeDrawer,

    handleDelete,
    handleSaved,
    refresh,
  } = usePassageCeintureDocuments();

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5 px-3 sm:px-4 lg:px-6">
        <PassageCeintureDocumentsHeader
          canManage={canManage}
          loading={loading}
          onRefresh={refresh}
          onCreate={openCreateDrawer}
        />

        <PassageCeintureDocumentsKpis
          stats={stats}
          loading={loading}
          canManage={canManage}
        />

        <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-4 sm:p-5 lg:p-6">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Ressources pédagogiques
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                  Documents de passage de ceinture
                </h2>

                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Retrouvez les fiches, visuels et PDF utiles pour préparer les
                  passages de ceinture. Les documents sont classés par ceinture
                  et peuvent être filtrés rapidement.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
                <span className="text-slate-500 dark:text-slate-400">
                  Affichés :
                </span>{" "}
                <span className="font-bold text-slate-900 dark:text-white">
                  {filteredDocuments.length}
                </span>
                <span className="text-slate-500 dark:text-slate-400">
                  {" "}
                  / {documents.length}
                </span>
              </div>
            </div>

            <div className="mt-5">
              <PassageCeintureDocumentsToolbar
                ui={ui}
                updateUi={updateUi}
                debouncedSearch={debouncedSearch}
                setDebouncedSearch={setDebouncedSearch}
                belts={belts}
                canManage={canManage}
                onReset={resetFilters}
                onCreate={openCreateDrawer}
              />
            </div>

            {loading ? (
              <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {Array.from({ length: 8 }).map((_, index) => (
                  <PassageCeintureDocumentSkeleton key={index} />
                ))}
              </div>
            ) : filteredDocuments.length === 0 ? (
              <PassageCeintureDocumentsEmptyState
                canManage={canManage}
                onReset={resetFilters}
                onCreate={openCreateDrawer}
              />
            ) : (
              <>
                <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {visibleDocuments.map((document) => (
                    <PassageCeintureDocumentCard
                      key={document.id}
                      document={document}
                      canManage={canManage}
                      onOpen={() => openReadDrawer(document)}
                      onEdit={() => openEditDrawer(document)}
                      onDelete={() => handleDelete(document)}
                    />
                  ))}
                </div>

                {visibleDocuments.length < filteredDocuments.length && (
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      onClick={loadMore}
                      className="rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white transition hover:bg-indigo-800"
                    >
                      Charger plus
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </div>

      <PassageCeintureDocumentDrawer
        isOpen={
          !!openedDocument || !!editingDocument || drawerMode === "create"
        }
        mode={drawerMode}
        passageDocument={editingDocument || openedDocument}
        belts={belts}
        canManage={canManage}
        onClose={closeDrawer}
        onSaved={handleSaved}
      />

      <ToastContainer />
    </section>
  );
}
